import { SORTORDER } from '../../utils/constants'

const ACCOUNTDETAILS = 'accountdetails'
const PERSONALDETAILS = 'personaldetails'
const USERS = 'users'

const getTableHeadings = (isSuperAdmin, isAdmin, isViewOnly) => {
  return [
    {
      id: 'name',
      header: 'NAME',
      isLink: isSuperAdmin || isAdmin || isViewOnly
    },
    {
      id: 'account.company_name',
      header: 'ACCOUNT',
      isSortable: true,
      sortOrder: SORTORDER.ASC,
    },
    {
      id: 'roles.0',
      header: 'ROLE',
      isSortable: true,
      sortOrder: SORTORDER.ASC,
    },
    {
      id: 'status',
      header: 'STATUS'
    }
  ]
}

const roles = {
  SUPER_ADMIN: 'Super Admin',
  SUPER_ADMIN_VIEW_ONLY: 'View Only',
  ACCOUNT_ADMIN: 'Account Admin',
  ACCOUNT_USER: 'Account User'
}

const SUPER_ADMIN = 'SUPER_ADMIN'
const SUPER_ADMIN_VIEW_ONLY = 'SUPER_ADMIN_VIEW_ONLY'
const ACCOUNT_ADMIN = 'ACCOUNT_ADMIN'
const ACCOUNT_USER = 'ACCOUNT_USER'

export {
  ACCOUNTDETAILS,
  PERSONALDETAILS,
  USERS,
  getTableHeadings,
  SUPER_ADMIN,
  SUPER_ADMIN_VIEW_ONLY,
  ACCOUNT_ADMIN,
  ACCOUNT_USER,
  roles
}



